import { cpf, cnpj } from 'cpf-cnpj-validator'

export const onlyCpjCNPJvalid = (data: any[] | null): any[] | null => {
  if (data === null) return null
  return data.filter(
    (e) =>
      cpf.isValid(e.nationalRegistration) ||
      cnpj.isValid(e.nationalRegistration)
  )
}
